<template>

<div v-if="!showDetails" class="orders loader-block-parent">
    <div v-show="isLoading" class="loader-block">
        <div>
            <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
        </div>
    </div>
    <div class="orders__table-wrapper">
        <table>
            <thead>
            <tr>
                <th></th>
                <th>{{ $t('project_details.orders.table.order_number') }}</th>
                <th>{{ $t('project_details.orders.table.realization_time') }}</th>
                <th>{{ $t('project_details.orders.table.status') }}</th>
                <th v-if="auth.user.role == Role.Architect">{{ $t('project_details.orders.table.estimated_architect_commission') }}</th>
                <th>{{ $t('project_details.orders.table.total_value') }}</th>
                <th></th>
            </tr>
            </thead>
            <tbody>

                <tr v-if="!isLoading && !orders.length" class="loading-row">
                    <td colspan="8">{{ $t('project_details.orders.table.no_orders') }}</td>
                </tr>
                <tr v-for="(order, index) in orders">
                    <td>{{ index + 1 }}</td>
                    <td>{{ order.id }}</td>
                    <td>{{ formatDate(order.expectedCompletionDate) }}</td>
                    <td>{{ order.fulfillmentStatus ? $t('project_details.orders.fulfillmentStatus.' + order.fulfillmentStatus) : '' }}</td>
                    <td v-if="auth.user.role == Role.Architect">{{ order.architectCommission }}</td>
                    <td>{{ order.price }}</td>
                    <td class="order-buttons">
                        <button @click.prevent="viewOrderDetails(order)">Szczegóły</button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<order-details v-if="showDetails"
    @back="back"
   :order="selectedOrder"
/>

</template>

<script>
import OrderDetails from "@/views/user/architect/OrderDetails";
import {ref} from "vue";
import axios from "axios";
import ApiHelper from "@/helpsers/api.helper";
import router from "@/router";
import authHelper from "@/helpsers/auth.helper";
import moment from "moment";
import {useAuthStore} from "@/stores/auth.store";
import {Role} from "@/helpsers/role.helper";

export default {
    name: "Orders",
    components: {OrderDetails},
    setup() {
        const showDetails = ref(router.currentRoute.value.params?.nestedTab == 'details');
        let isLoading = ref(false);
        let orders = ref([]);
        let selectedOrder = ref({});
        const auth = useAuthStore();

        function formatDate(date) {
            return date ? moment(date).format('MM.DD.YYYY') : ''
        }

        function fetchOrders() {
            isLoading.value = true;
            axios.get(ApiHelper.getProjectOrdersUrl(router.currentRoute.value.params.id), {
                headers: authHelper.authHeader(),
            }).then(result => {
                orders.value = result.data ?? [];
                passOrderToDetails();
                isLoading.value = false;
            }).catch(errorResponse => {
                if(errorResponse.response.data.code == '404')
                    router.push({ path: '/not-found' });
                isLoading.value = false;
            })
        }

        fetchOrders();

        function passOrderToDetails() {
            if(showDetails.value)
                selectedOrder.value = orders.value.find(order => order.id == router.currentRoute.value.params.nestedId)
        }

        function back() {
            let urlName = 'project-details';
            if (auth.user.role == Role.Admin)
                urlName = 'admin.project-details';
            router.push({name: urlName, params: {
                id: router.currentRoute.value.params.id,
                activeTab: router.currentRoute.value.params.activeTab,
            }})
            showDetails.value = false;
        }

        function viewOrderDetails(orderData) {
            let urlName = 'project-details';
            if (auth.user.role == Role.Admin)
                urlName = 'admin.project-details';
            router.push({name: urlName, params: {
                id: router.currentRoute.value.params.id,
                activeTab: router.currentRoute.value.params.activeTab,
                nestedTab: 'details',
                nestedId: orderData.id
            }})
            showDetails.value = true;
            selectedOrder.value = orderData;
        }

        return {
            showDetails,
            back,
            orders,
            isLoading,
            formatDate,
            viewOrderDetails,
            selectedOrder,
            auth,
            Role,
        }
    }
}
</script>

<style scoped lang="scss">

.orders {
    &__table {
        &-wrapper {
            overflow-y: auto;
            overflow-x: visible;
            table {
                width: 100%;
                thead {
                    tr {
                        padding: 22px 5px;
                        background: #F4F3F3;

                        th {
                            font: normal normal 600 2rem/2.4rem Montserrat;
                            padding: 20px 5px;
                            position: relative;
                        }
                    }
                }

                tbody {
                    text-align: center;

                    td {
                        border-bottom: 1px solid #D4D1D1;
                        padding: 20px;

                        &:first-child {
                            border-left: 1px solid #D4D1D1;
                            border-right: 1px solid #D4D1D1;
                        }

                        &:last-child {
                            border-right: 1px solid #D4D1D1;
                        }

                    }

                    .order-buttons {
                       button {
                           border: 1px solid #FF7366;
                           border-radius: 5px;
                           background: white;
                           color: black;
                           padding: 13px 30px;
                           cursor: pointer;
                           &:hover {
                               background: #FF7366;
                               color: white;

                           }
                       }
                    }
                }
            }
        }
    }
}

</style>
